export enum DataSourceStatus {
  Idle,
  InProgress,
  Completed,
  Failed,
  Cancelled,
}
